import {
	LiveRamp_Vendor,
	Required_Purposes,
} from "@/config/reach/common/constants/consent";
import { loginRadiusStore } from "@/store/loginRadiusStore";
import type { LiveRampModule } from "@/ts/module";
import type { Exactly } from "@/ts/types";
import { appendHtmlToHead } from "@/utils/dom";
import { getModules } from "@/utils/modules";
import { LIVERAMP_TAG } from "@/vendors/liveRamp";

const loadScript = () => {
	appendHtmlToHead(LIVERAMP_TAG);
};

const ready = async (): Promise<boolean> => {
	const maxWait = 500;
	let waitingTimeRemaining: number = maxWait;
	return new Promise((resolve) => {
		const checkConditions = () => {
			if (window.atsenvelopemodule) {
				resolve(true);
			} else {
				waitingTimeRemaining -= 100;
				if (waitingTimeRemaining <= 0) {
					resolve(true);
				}
				setTimeout(checkConditions, 100);
			}
		};
		checkConditions();
	});
};

const identify = (): void => {
	const state = loginRadiusStore.getState();
	const email = state.email;
	if (email) {
		window.atsenvelopemodule?.setAdditionalData({
			type: "email",
			id: email,
		});
	}
};

const updateEmailOnEmailChange = (): void => {
	loginRadiusStore.subscribe((state) => state.email, identify);
};

export class LiveRamp implements Exactly<LiveRampModule, LiveRamp> {
	name = "LiveRamp" as const;
	async init(): Promise<void> {
		const [consentModule] = await getModules(["Consent"]);
		const consented = await consentModule.run({
			vendorId: LiveRamp_Vendor,
			purposes: Required_Purposes,
		});
		if (consented) {
			loadScript();
			await ready();
			identify();
			updateEmailOnEmailChange();
		}
	}
}
